import React from 'react';
import styled from 'styled-components';
import { theme } from '../../../theme';
import { BodyText } from '../../typography';

export type LabelProps = {
  float: boolean;
  isCompact?: boolean;
  required?: boolean;
  value: string;
};

export type LabelStyleProps = {
  float: boolean;
  isCompact?: boolean;
};

const StyledLabel = styled(BodyText)<LabelStyleProps>`
  ${({ isCompact }) =>
    isCompact
      ? `
      color: ${theme.colors.neutrals.solidGrays[2]}; 
      left: ${theme.spacings[3].rem};
      position: absolute;
      top: ${theme.spacings[3].rem};
      transition: left 0.2s, line-height 0.2s, font-size 0.2s, padding 0.2s, top 0.2s;
      z-index: 0;
    `
      : `
      font-weight: 700;
      margin-bottom: ${theme.spacings[2].rem};
  `}

  ${({ float }) =>
    float &&
    `
      top: ${theme.spacings[2].rem}; 
      transform: translateY(0);
      z-index: 1;
  `}
`;

const Asterisk = styled.span`
  color: ${theme.colors.primary.graysGray};
  left: 2px;
  margin-bottom: ${theme.spacings[2].rem};
  position: relative;
  top: -1px;

  &::after {
    content: '*';
    position: absolute;
  }
`;

export const Label: React.FC<LabelProps> = ({
  float,
  isCompact = false,
  required = false,
  value,
  ...props
}) => (
  <StyledLabel
    float={float}
    size={float ? 'xs' : 'md'}
    isCompact={isCompact}
    {...props}
  >
    {value}
    {required && <Asterisk />}
  </StyledLabel>
);
